import { useState } from 'react';

const useLayout = () => {
  const [handle_el, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorEl(null);
  };

  return {
    handle_el,
    handleOpenUserMenu,
    handleCloseUserMenu,
  };
};

export default useLayout;
